import { match } from "path-to-regexp";

export const BASE_URL = "/";
export const WORKSPACE_URL = "/workspace";
export const PAGE_NOT_FOUND_URL = "/404";
export const SERVER_ERROR_URL = "/500";
export const APPLICATIONS_URL = `/applications`;
export const HOME_URL = `/home`;
export const HOME_MODULES_URL = `/home/modules`;
export const LICENSE_CHECK_PATH = "/license";
export const MIGRATIONS_URL = "/migrations";

export const TEMPLATES_PATH = "/templates";
export const TEMPLATES_ID_PATH = "/templates/:templateId";

export const USER_AUTH_URL = "/user";
export const PROFILE = "/profile";
export const GIT_PROFILE_ROUTE = `${PROFILE}/git`;
export const USERS_URL = "/users";
export const SETUP = "/setup/welcome";
export const FORGOT_PASSWORD_URL = `${USER_AUTH_URL}/forgotPassword`;
export const RESET_PASSWORD_URL = `${USER_AUTH_URL}/resetPassword`;
export const BASE_SIGNUP_URL = `/signup`;
export const SIGN_UP_URL = `${USER_AUTH_URL}/signup`;
export const BASE_LOGIN_URL = `/login`;
export const AUTH_LOGIN_URL = `${USER_AUTH_URL}/login`;
export const SIGNUP_SUCCESS_URL = `/signup-success`;
export const WORKSPACE_INVITE_USERS_PAGE_URL = `${WORKSPACE_URL}/invite`;
export const WORKSPACE_SETTINGS_PAGE_URL = `${WORKSPACE_URL}/settings`;
export const WORKSPACE_SETTINGS_GENERAL_PAGE_URL = `${WORKSPACE_URL}/settings/general`;
export const WORKSPACE_SETTINGS_MEMBERS_PAGE_URL = `${WORKSPACE_URL}/settings/members`;
export const WORKSPACE_SETTINGS_LICENSE_PAGE_URL = `/settings/license`;
export const MODULES_URL = `/modules`;
export const DATA_MODELING_URL = `/data-modeling`;
export const FOLDER_DETAIL_URL = `/modules/:folderId`;
export const DATA_MODEL_EDITOR_URL = `/data-model-editor`;
export const WORKFLOW_APPROVAL_URL = `/workflow-approval`;
/** 审批流url */
/** 流程设计 */
export const APPROVAL_PROCESS_PROCESS_DESIGN_URL = `/af-process-design`;
/** 流程设计详情 */
export const APPROVAL_PROCESS_PROCESS_DESIGN_DETAIL_URL = `/af-process-design/:processId`;
/** 待审批 */
export const APPROVAL_PROCESS_PENDING_APPROVAL_URL = `/af-pending-approval`;
/** 我的申请 */
export const APPROVAL_PROCESS_MY_APPLICATION_URL = `/af-my-application`;
/** 我的接收 */
export const APPROVAL_PROCESS_MY_RECEIVED_URL = `/af-my-received`;
/** 我的表单 */
export const APPROVAL_PROCESS_MY_FORM_URL = `/af-my-form`;
/** 已审批 */
export const APPROVAL_PROCESS_APPROVED_URL = `/af-approved`;

export const TEMPLATES_URL = `/new-templates`;
export const DATA_MODEL_SETTING_URL = `/data-model-setting`;
export const AGENT_URL = `/agent`;
export const WORKFLOW_URL = `/workflow`;

export const matchApplicationPath = match(APPLICATIONS_URL);
export const matchHomePath = match(HOME_URL);
export const matchTemplatesPath = match(TEMPLATES_PATH);
export const matchTemplatesIdPath = match(TEMPLATES_ID_PATH);
export const matchModulesPath = match(MODULES_URL);
